module.exports = __webpack_public_path__ + "static/media/21ECLAC34.99c93fb6.jpg";